import React from "react";
import "./Product.css";

const Product = () => {
  return (
    <div className="product-container">
      <div className="cont-product">
        <h1>Need Some Help?</h1>
        <div className="help-btn">
          <button className="btn-help">Get In Touch</button>
        </div>
      </div>
    </div>
  );
};

export default Product;
